// extracted by mini-css-extract-plugin
export default {"project":"HMgad","projectTitle":"yQpbF","endDate":"KsPRj","downloadButton":"uLRkJ","noDownload":"IYnxO","prProjectNavigationButtons":"NMueB"};